import { ReactComponent as OfficeIcon } from 'assets/icons/icon-office.svg';
import CardWithAside from 'components/Card/CardWithAside';
import ErrorMessage from 'components/ErrorMessage/ErrorMessage';
import Page from 'components/Page';
import PageIcon from 'components/PageIcon/PageIcon';
import ResetAndSubmitButton from 'components/ResetAndSubmitButton/ResetAndSubmitButton';
import React from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'routeMap';
import { useWrappedUrqlMutation, useSearchParams } from 'toolbox';
import { useCreateBusinessUnitMutation } from './CreateBusinessUnit.generated';
import { CreateBusinessUnitForm } from './forms';
import { useGetOrganisationQuery } from 'components/Admin/orgs/queries/GetOrganisation.generated';
import GoBackButton from 'components/GoBackButton/GoBackButton';

export const CreateBusinessUnit = () => {
  const navigate = useNavigate();
  const params = useSearchParams<{ orgId: string }>();
  const [initialOptionResult] = useGetOrganisationQuery({
    pause: !params.orgId,
    variables: {
      id: Number(params.orgId),
    },
  });
  const create = useWrappedUrqlMutation(useCreateBusinessUnitMutation, {
    onSuccess: (result) => {
      toast.info('Created business unit successfully.');
      navigate.viewBusinessUnit({
        params: {
          id: result.insert_business_units.returning?.[0].id,
        },
      });
    },
    onError: () => {},
  });
  return (
    <Page icon={<PageIcon Icon={OfficeIcon} />} title="New Business Unit">
      <GoBackButton>Back To Org</GoBackButton>
      <CreateBusinessUnitForm.Wrapper
        onSubmit={create.dispatch}
        initialValues={{ organisation_id: Number(params.orgId) }}
      >
        <CardWithAside
          title="Manage Business Unit"
          footer={<ResetAndSubmitButton />}
        >
          <CreateBusinessUnitForm.Inputs.name label="Name" />
          <CreateBusinessUnitForm.Inputs.organisation_id
            label="Organisation"
            initialOption={initialOptionResult.data?.organisations_by_pk}
          />
          <ErrorMessage {...create} />
        </CardWithAside>
      </CreateBusinessUnitForm.Wrapper>
    </Page>
  );
};
